import { useEffect } from "react";

function setMeta(selector, content) {
  const element = document.head.querySelector(selector);
  if (element) element.setAttribute("content", content);
}

export default function SEO({ title, fullTitle: specifiedTitle, description, canonical, noIndex = false }) {
  const siteName = "StunM";
  const fullTitle = specifiedTitle || (title ? `${title} | ${siteName}` : `${siteName} - Strategy, Technology, Unified Marketing`);
  const desc = description || "Empowering businesses with strategy decks, marketing workflows, and campaign management.";
  const hasWindow = typeof window !== "undefined";
  const origin = hasWindow ? window.location.origin : "https://ai.stunm.in";
  const pathname = hasWindow ? window.location.pathname : "/";
  const url = canonical || `${origin}${pathname}`;

  useEffect(() => {
    document.title = fullTitle;
    setMeta('meta[name="description"]', desc);
    setMeta('meta[property="og:title"]', fullTitle);
    setMeta('meta[property="og:description"]', desc);
    setMeta('meta[property="og:url"]', url);
    setMeta('meta[name="twitter:title"]', fullTitle);
    setMeta('meta[name="twitter:description"]', desc);
    setMeta('meta[name="robots"]', noIndex ? "noindex,follow" : "index, follow");

    const canonicalLink = document.head.querySelector('link[rel="canonical"]');
    if (canonicalLink) canonicalLink.setAttribute("href", url);
  }, [desc, fullTitle, noIndex, url]);

  return null;
}
